import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { useHistory } from 'react-router-dom';
// import BatteryInfo from './BatteryInfo'; --> uncomment when needed
import ErrorInfo from './ErrorInfo';
import { getDevices } from '../store/actions/devices';

const columns = [
  { id: 'id', label: 'Id', minWidth: 100 },
  { id: 'mac_address', label: 'Monitor ID', minWidth: 170 },
  {
    id: 'patient',
    label: 'Patient',
    minWidth: 170,
    format: (value) => (value ? `${value.first_name} ${value.last_name}` : 'Unlinked'),
  },
  // Currently no capabilities to read battery. Uncomment when needed.
  // {
  //   id: 'battery',
  //   label: 'Battery',
  //   minWidth: 100,
  //   format: (value) => (value ? <BatteryInfo battery={value} /> : null),
  // },
  {
    id: 'last_message_time',
    label: 'Last Online',
    minWidth: 100,
    format: (value) => {
      if (value) {
        return moment(value).format('M/DD/YY hh:mm a');
      }
      return null;
    },
  },
  {
    id: 'alert',
    label: 'Error',
    minWidth: 100,
    format: (value) => {
      if (value) {
        return <ErrorInfo status={alert ? 7 : 0} />;
      }
      return null;
    },
  },
];

const DevicesTable = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const devicesList = useSelector((state) => state.devices.devicesList);
  const deviceCount = useSelector((state) => state.devices.deviceCount);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    dispatch(getDevices());
    const refreshTimer = setInterval(() => {
      dispatch(getDevices());
    }, 60000);
    return () => {
      clearInterval(refreshTimer);
    };
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getDevices(false, newPage + 1, rowsPerPage));
  };

  const handleSetDevice = (data) => {
    history.push(`./monitors/${data.id}`);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    dispatch(getDevices(false, 1, +event.target.value));
  };

  const useStyles = makeStyles(() => ({
    root: {
      width: '100%',
      height: '100%',
    },
    content: {
      flexGrow: 1,
      borderRadius: 4,
    },
    table: {
      width: '100%',
    },
    headerCell: {
      backgroundColor: '#526488',
      fontWeight: 'bold',
      textAlign: 'center',
      color: 'white',
    },
    cell: {
      textAlign: 'center',
    },
  }));

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <TableContainer className={classes.content}>
        <Table stickyHeader aria-label="sticky table" className={classes.table}>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  className={classes.headerCell}
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {devicesList.map((row, index) => {
              return (
                <TableRow
                  className={classes.row}
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  onClick={() => {
                    handleSetDevice(row);
                  }}
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                >
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align} className={classes.cell}>
                        {column.format ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={deviceCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default DevicesTable;
